import serialize from "json-form-data";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const api_url = "/index.php";

function formatDocument(data) {
    data.law_statuses = data.law_statuses.join(",");
    data.blocking_condition = JSON.stringify(data.blocking_condition);
    data.gender = data.gender;
    data.conditions = data.conditions.map((c) => {
        if (c && (c.citizenship_ids || c.posts_codes)) {
            const condition = { citizenship_limit: c.citizenship_limit };
            if (c.citizenship_ids) {
                condition.citizenship_ids = c.citizenship_ids.join(",");
            }
            if (c.posts_codes) {
                condition.posts_codes = c.posts_codes.join(",");
            }
            return condition;
        }
        return {};
    });

    data.notifications = data.notifications.map((n) => {
        if (n && n.filial_ids.length && n.user_id) {
            n.filial_ids = JSON.stringify(n.filial_ids);
            return n;
        }
        return {};
    });

    return data;
}

export default {
    namespaced: true,

    state: {
        statusesLoading: false,
        citizenshipsLoading: false,
        usersLoading: false,
        positionsLoading: false,
        filialsLoading: false,

        doctypesDictionary: [],
        statusesDictionary: [],
        citizenshipsDictionary: [],
        usersDictionary: [],
        positionsDictionary: [],
        filialsDictionary: [],
    },

    mutations: {
        setDoctypes(state, dictionary) {
            state.doctypesDictionary = dictionary.map((item) => ({
                label: item.name,
                value: item.id,
            }));
        },

        loadStatuses(state) {
            state.statusesLoading = true;
        },
        setStatuses(state, dictionary) {
            state.statusesDictionary = dictionary.map((item) => ({
                label: item.name,
                value: item.id,
            }));
        },

        loadCitizenships(state) {
            state.citizenshipsLoading = true;
        },
        setCitizenships(state, dictionary) {
            state.citizenshipsDictionary = dictionary.map((item) => ({
                label: item.name,
                value: item.id,
            }));
        },

        loadUsers(state) {
            state.usersLoading = true;
        },
        setUsers(state, dictionary) {
            state.usersDictionary = dictionary.map((item) => ({
                label: item.name,
                value: item.id,
            }));
        },

        loadPositions(state) {
            state.positionsLoading = true;
        },
        setPositions(state, dictionary) {
            state.positionsDictionary = dictionary.map((item) => ({
                label: item.name,
                value: item.id,
            }));
        },

        loadFilials(state) {
            state.filialsLoading = true;
        },
        setFilials(state, dictionary) {
            state.filialsDictionary = dictionary.map((item) => ({
                label: item.name,
                value: item.id,
            }));
        },
    },

    actions: {
        async loadDocument(ctx, params) {
            const token = ctx.rootState.authToken;
            return fetch(addAuthKey(`${api_url}/?r=api/type-documents/info&type_doc_id=${params.id}`, token))
                .then((res) => res.json())
                .then((json) => json.response);
        },

        async createDocument(ctx, params) {
            const token = ctx.rootState.authToken;
            const formData = serialize({
                TypeDocuments: formatDocument(params.data),
            });

            return fetch(addAuthKey(`${api_url}/?r=api/type-documents/create`, token), {
                method: "POST",
                body: formData,
            }).then((res) => res.json());
        },

        async updateDocument(ctx, params) {
            const token = ctx.rootState.authToken;
            const formData = serialize({
                TypeDocuments: formatDocument(params.data),
            });

            return fetch(addAuthKey(`${api_url}/?r=api/type-documents/edit&type_doc_id=${params.id}`, token), {
                method: "POST",
                body: formData,
            }).then((res) => res.json());
        },

        async loadDoctypes(ctx) {
            const token = ctx.rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/type-documents/groups-dictionary`, token));
            const json = await res.json();
            ctx.commit("setDoctypes", json.response);
        },

        async loadStatuses(ctx) {
            if (ctx.state.statusesLoading) return;

            ctx.commit("loadStatuses");

            const token = ctx.rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/type-documents/law-status-dictionary`, token));
            const json = await res.json();
            ctx.commit("setStatuses", json.response);
        },

        async loadCitizenships(ctx) {
            if (ctx.state.citizenshipsLoading) return;

            ctx.commit("loadCitizenships");

            const token = ctx.rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/type-documents/citizenships-dictionary`, token));
            const json = await res.json();
            ctx.commit("setCitizenships", json.response);
        },

        async loadUsers(ctx) {
            if (ctx.state.usersLoading) return;

            ctx.commit("loadUsers");

            const token = ctx.rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/type-documents/active-users-list`, token));
            const json = await res.json();
            ctx.commit("setUsers", json.response);
        },

        async loadPositions(ctx) {
            if (ctx.state.positionsLoading) return;

            ctx.commit("loadPositions");

            const token = ctx.rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/worker-profile/posts-list`, token));
            const json = await res.json();
            ctx.commit("setPositions", json.response);
        },

        async loadFilials(ctx) {
            if (ctx.state.filialsLoading) return;

            ctx.commit("loadFilials");

            const token = ctx.rootState.authToken;
            const res = await fetch(addAuthKey(`${api_url}/?r=api/type-documents/filials`, token));
            const json = await res.json();
            ctx.commit("setFilials", json.response);
        },
    },
};
